import React from "react";
import {
  executePanelSamplePhoneIntent,
  setPendingPanelSamplePhoneIntent,
  STORE_SALES_PHONE_TEL,
} from "../service";

/**
 * Catalog banner for free panel sample — call sales after login.
 * @param {{
 *   className?: string,
 *   isLoggedIn?: boolean,
 *   onAuthRequired?: () => void,
 * }} props
 */
export default function StoreFreePanelSampleBanner({
  className,
  isLoggedIn = false,
  onAuthRequired,
}) {
  const phoneHref = `tel:${STORE_SALES_PHONE_TEL}`;

  const handleContactClick = (e) => {
    e.preventDefault();
    if (!isLoggedIn) {
      setPendingPanelSamplePhoneIntent();
      onAuthRequired?.();
      return;
    }
    executePanelSamplePhoneIntent();
  };

  return (
    <div className={className}>
      <div
        className="rounded-3 p-2 d-flex flex-wrap align-items-center justify-content-center gap-1 border w-100"
        style={{
          background: "#FDEA9F",
          borderColor: "#fdea9f",
        }}
      >
        <span className="text-dark fw-bold" style={{ letterSpacing: "0.01em" }}>
          Want panel samples delivered to your place?
        </span>
        <a
          href={phoneHref}
          onClick={handleContactClick}
          className="fw-bold text-primary text-decoration-none d-inline-flex align-items-center gap-1"
        >
          <i className="fa-solid fa-phone text-success" aria-hidden />
          Talk to sales team{" "}
          <span className="small text-secondary fw-normal">(9 AM to 9 PM)</span>
        </a>
      </div>
    </div>
  );
}
